// Import types
import { getChannelsGroupTree } from "./layout";
import { ChannelWithPosition } from "./types";

export const getChannelVerticalPosition = (
  channel: ChannelWithPosition,
  isVerticalMode: boolean
) => {
  if (isVerticalMode) {
    return {
      ...channel,
      position: {
        ...channel.position,
        left: channel.position.top,
        width: channel.position.height,
      },
    };
  }

  return channel;
};

export const getChannelGroupTreeProps = (channel: ChannelWithPosition) => {
  const data = {
    ...channel,
    nestedChildren: [],
    isFirstNestedChild: false,
    isLastNestedChild: false,
  };

  const getChanelGroupTree = (uuid?: string) =>
    channelsGroupTree[uuid ?? ""] ?? null;

  const channelsGroupTree = getChannelsGroupTree();
  const channelGroupTree = getChanelGroupTree(channel.uuid);
  const channelNestedGroupTree = getChanelGroupTree(
    channel.parentChannelUuid ?? ""
  );

  if (channel.parentChannelUuid && channelNestedGroupTree) {
    const isFirstNestedChild =
      channelNestedGroupTree.nestedChildren?.at(0) === channel.uuid;
    const isLastNestedChild =
      channelNestedGroupTree.nestedChildren?.at(-1) === channel.uuid;
    return {
      ...data,
      isFirstNestedChild,
      isLastNestedChild,
    };
  } else if (channelGroupTree) {
    return {
      ...data,
      nestedChildren: channelGroupTree.nestedChildren,
    };
  }

  return data;
};
